module.exports = __webpack_public_path__ + "img/vision.6144e470.png";